(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hhs-offer"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var section = document.getElementById('hhs-offer');
    if (!section) return;
    var swatches = section.querySelectorAll('[data-hhs-scent]');
    var idInput = section.querySelector('.sellingPlanVarID');
    var label = section.querySelector('[data-hhs-scent-label]');
    swatches.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var id = btn.getAttribute('data-variant-id');
        var title = btn.getAttribute('data-variant-title');
        if (idInput && id) idInput.value = id;
        if (label && title) label.textContent = title;
        swatches.forEach(function (b) {
          b.classList.remove('is-active', 'border-tebrown');
          b.classList.add('border-tebrown/20');
          b.setAttribute('aria-pressed', 'false');
        });
        btn.classList.add('is-active', 'border-tebrown');
        btn.classList.remove('border-tebrown/20');
        btn.setAttribute('aria-pressed', 'true');
      });
    });

    // Product-detail accordions — self-contained, no external JS dependency.
    section.querySelectorAll('[data-hhs-acc-trigger]').forEach(function (t) {
      t.addEventListener('click', function () {
        var item = t.closest('[data-hhs-acc-item]');
        if (!item) return;
        var panel = item.querySelector('[data-hhs-acc-panel]');
        var open = item.classList.toggle('is-open');
        t.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (panel) panel.style.maxHeight = open ? panel.scrollHeight + 'px' : '0px';
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hhs-port-product-offer"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var sections = document.querySelectorAll('.hhs-port-offer');
    function getGiftVariantIds(productForm) {
      return (productForm.getAttribute('data-hhs-gift-variant-ids') || '')
        .split(',')
        .map(function (id) { return parseInt(id, 10); })
        .filter(function (id) { return id && !Number.isNaN(id); });
    }

    function setButtonLoading(button, isLoading) {
      if (!button) return;
      button.disabled = isLoading;
      button.classList.toggle('loading', isLoading);
      if (isLoading) button.setAttribute('aria-busy', 'true');
      else button.removeAttribute('aria-busy');
    }

    function addOfferAndGifts(evt) {
      var form = evt.target;
      var productForm = form.closest('.hhs-port-product-form');
      if (!productForm) return;
      var giftVariantIds = getGiftVariantIds(productForm);
      if (!giftVariantIds.length) return;

      evt.preventDefault();
      evt.stopPropagation();
      if (typeof evt.stopImmediatePropagation === 'function') evt.stopImmediatePropagation();

      var submitter = evt.submitter || form.querySelector('[type="submit"], button[name="add"]');
      var mainVariantId = parseInt((form.querySelector('[name="id"]') || {}).value, 10);
      if (!mainVariantId) return;
      var quantity = parseInt((form.querySelector('[name="quantity"]') || {}).value, 10) || 1;
      var sellingPlan = (form.querySelector('[name="selling_plan"]') || {}).value;
      var mainItem = { id: mainVariantId, quantity: quantity };
      if (sellingPlan) mainItem.selling_plan = sellingPlan;
      var items = [mainItem].concat(giftVariantIds.map(function (giftVariantId) {
        return { id: giftVariantId, quantity: quantity };
      }));

      setButtonLoading(submitter, true);
      fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({ items: items })
      })
        .then(function (response) {
          return response.json().then(function (data) {
            if (!response.ok) throw data;
            return data;
          });
        })
        .then(function () {
          window.location.href = '/checkout';
        })
        .catch(function (error) {
          console.error('[HHS] Could not add offer + free gifts before checkout', error);
          window.location.href = '/cart';
        })
        .finally(function () {
          setButtonLoading(submitter, false);
        });
    }

    sections.forEach(function (section) {
      var productForm = section.querySelector('.hhs-port-product-form');
      var form = productForm ? productForm.querySelector('form[action*="/cart/add"]') : null;
      if (form) form.addEventListener('submit', addOfferAndGifts, true);
      var swatches = section.querySelectorAll('[data-hhs-scent]');
      var idInput = section.querySelector('.sellingPlanVarID');
      var label = section.querySelector('[data-hhs-scent-label]');
      swatches.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var id = btn.getAttribute('data-variant-id');
          var title = btn.getAttribute('data-variant-title');
          if (idInput && id) idInput.value = id;
          if (label && title) label.textContent = title;
          swatches.forEach(function (b) {
            b.classList.remove('r-v8dna');
            b.setAttribute('aria-selected', 'false');
          });
          btn.classList.add('r-v8dna');
          btn.setAttribute('aria-selected', 'true');
        });
        // keyboard support (Enter/Space) since swatches are role=option divs
        btn.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); btn.click(); }
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
